import axios from 'axios'

const { NODE_ENV } = process.env
const API_KEY = process.env.VUE_APP_API_KEY

// Initialize Cloud Firestore through Firebase
var config = {
  baseURL: NODE_ENV === 'development' ? 'http://localhost:8888/.netlify/functions/index' : '/.netlify/functions/index',
  headers: {
    common: {
      Authorization: API_KEY
    }
  }
}

const instance = axios.create(config)

export const findName = (uuid?: string) => {
  return instance.get('/name', {
    params: {
      id: uuid
    }
  })
}

export const addName = (params: any, uuid?: string) => {
  if (uuid) {
    return instance.put(`/name/${uuid}`, {
      ...params
    })
  } else {
    return instance.post('/name', {
      ...params
    })
  }
}

export const deleteName = (uuid: string) => {
  return instance.delete(`/name/${uuid}`)
}

export const findAttendance = (date: string) => {
  return instance.get('/attendance', {
    params: {
      date
    }
  })
}

export const addAttendance = (date: string, uuid: string) => {
  return instance.post(`/attendance/${date}`, {
    uuid
  })
}

export const deleteAttendance = (date: string, uuid: string) => {
  return instance.delete(`/attendance/${date}`, {
    data: {
      uuid
    }
  })
}
